export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/b5ced123-1078-4499-8745-02a2806a6f35/images/f6662299124c0ba3a0ecf1d2c1d9bf0c84165675eb3aee92d19990617f422d3c.png",
  escapeRoom: "https://static.prod-images.emergentagent.com/jobs/b5ced123-1078-4499-8745-02a2806a6f35/images/60e2a444314623cdc5daa57657bb0dea4aec0490f199eaaaf23ba74b7b20b571.png",
  geography: "https://static.prod-images.emergentagent.com/jobs/b5ced123-1078-4499-8745-02a2806a6f35/images/3e80191b547afce87addd2552e600c500ed424099e626e47d08265bc23debe8d.png",
  ai: "https://static.prod-images.emergentagent.com/jobs/b5ced123-1078-4499-8745-02a2806a6f35/images/9dfdd971537598215c887848246db3768ab8f3f5964583a830bd545e3265dca0.png",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
